import { useTranslation } from "react-i18next";
import { NeuButton, NeuInput } from "../../components/neu/Neu";

// شريط اختيار الجهة (للرجال/للنساء) وسرعة النطق.
export const VoiceTargetRow = ({ form, labelOf, target, setTarget, onSpeed }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      {["male", "female"].map((key) => (
        <NeuButton
          key={key}
          type="button"
          variant={target === key ? "primary" : undefined}
          className="px-3 py-2 text-[11px]"
          data-testid={`voice-target-${key}`}
          onClick={() => setTarget(key)}
        >
          {t(`greeting.for_${key}`)}: {labelOf ? labelOf(form[key]) : form[key]}
        </NeuButton>
      ))}
      <div className="flex items-center gap-2">
        <span className="text-[11px] text-muted-foreground">{t("greeting.speed")}</span>
        <NeuInput
          className="w-20"
          type="number"
          step="0.01"
          min="0.9"
          max="1.4"
          dir="ltr"
          data-testid="voice-speed"
          value={form.speed}
          onChange={(e) => onSpeed(e.target.value)}
        />
      </div>
    </div>
  );
};
